export default __webpack_public_path__ + "static/media/personal@2x.00345b1f.png";